// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__7ufj3","input":"Input_input__Y16zh","textarea":"Input_textarea__8cLl6"};